module.exports = __webpack_public_path__ + "img/63.97530140.jpg";